import { get } from 'lodash';
import { connect } from 'react-redux';

import CustomCollectionDescriptionModule from 'components/CustomCollectionDescriptionModule';
import CustomCollectionModel from 'models/CustomCollectionModel';
import { getCustomCollectionData } from 'state/selectors/collection';

const mapStateToProps = state => {
  const customCollection = new CustomCollectionModel(getCustomCollectionData(state));

  const content = get(customCollection, 'descriptionModule');

  return {
    content,
  };
};

export default connect(mapStateToProps)(CustomCollectionDescriptionModule);
